import { ReactNode } from 'react'
import { ToastOptions } from 'react-toastify'
import { ToastComponent, Toast } from '@opallabs/lapidary'

type BulkUpdateToastProps = {
  children?: ReactNode
}

export const BULK_SYNCHRONOUS_LIMIT = 60

export const defaultBulkToastStartOptions: ToastOptions = {
  toastId: 'bulk-update-start',
  type: 'info',
  autoClose: 5000,
  closeOnClick: true,
}

const defaultSyncStartMessage =
  "Your update is in progress and we'll let you know as soon as it finishes."

export const StartSyncBulkUpdateToast: ToastComponent<BulkUpdateToastProps> = ({
  children,
  ...toastProps
}) => {
  return (
    <Toast
      {...toastProps}
      title="Bulk update in progress"
      message={children ?? defaultSyncStartMessage}
    />
  )
}

const defaultAsyncStartMessage =
  'Your update is in progress and may take several minutes to complete.'

export const StartAsyncBulkUpdateToast: ToastComponent<
  BulkUpdateToastProps
> = ({ children, ...toastProps }) => {
  return (
    <Toast
      {...toastProps}
      title="Bulk update in progress"
      message={children ?? defaultAsyncStartMessage}
    />
  )
}
